export default __webpack_public_path__ + "static/hands-house-2e0048f2e4c45312d893b7d88aae7fd2.svg";